import { TypographyH2, TypographyP } from '@talentmesh/ui/components/typography';
import UIStrings from '@/Utils/UIStrings';

const IdentifyExperienceStepHeader = () => {
    return (
        <div className="flex flex-col items-center justify-center gap-2 py-5">
            <TypographyH2 className="text-foreground">{UIStrings.IdentifyApplicantExperience}</TypographyH2>
            <TypographyP className="text-foreground max-w-3xl text-center">
                {UIStrings.UseTalentmeshAIToIdentifyAndSetApplicantCriteria}
            </TypographyP>
        </div>
    );
};
export default IdentifyExperienceStepHeader;
